import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";

import GuiaDocente from "../../../components/GuiaDocente";
import Imagen1 from "../../../images/modulo12/casa.png";
import Imagen2 from "../../../images/modulo12/pizarra.png";
import Imagen3 from "../../../images/modulo12/grifo.png";
import Imagen4 from "../../../images/modulo12/telefonos.png";
import Imagen5 from "../../../images/modulo12/bus.png";
import Imagen6 from "../../../images/modulo12/medicinas.png";
import Imagen7 from "../../../images/modulo12/electrodomesticos.png";
import Imagen8 from "../../../images/modulo12/comida.png";

import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad5.mp3";

const Actividad8 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "1" },
    ans6: { value: "", valid: "", correctValue: "1" },
    ans7: { value: "", valid: "", correctValue: "0" },
    ans8: { value: "", valid: "", correctValue: "1" },
  });

  /*const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option3" },
    ans2: { value: "", valid: "", correctValue: "option2" },
  });*/
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[6];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[7].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[7].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[5].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[5].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };
  /*const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };*/

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul className="">
            <li>
            Las personas no podemos vivir bien si nuestras necesidades básicas no están cubiertas. Abajo aparecen diferentes tipos de necesidades. Marca con un check aquellas que creas que son necesidades básicas.
            </li>
          </ul>
        </div>
      </div>

      <div className="row g-4 align-items-end">
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen1} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans1.valid}
              type="checkbox"
              value="1"
              checked={answers.ans1.value === "1"}
              onChange={(event) => handleAnswers(event, "ans1")}
            />{" "}
            <p className="w-200 ms-2">
              Tener un sitio adecuado y seguro donde vivir.
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen2} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans2.valid}
              type="checkbox"
              value="1"
              checked={answers.ans2.value === "1"}
              onChange={(event) => handleAnswers(event, "ans2")}
            />{" "}
            <p className="w-200 ms-2">Recibir una buena educación.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen3} alt="Peruanos" className="img-fluid img-80" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans3.valid}
              type="checkbox"
              value="1"
              checked={answers.ans3.value === "1"}
              onChange={(event) => handleAnswers(event, "ans3")}
            />{" "}
            <p className="w-200 ms-2">Tener agua y desagüe en mi vivienda.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen4} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans4.valid}
              type="checkbox"
              value="1"
              checked={answers.ans4.value === "1"}
              onChange={(event) => handleAnswers(event, "ans4")}
            />{" "}
            <p className="w-200 ms-2">Poseer telefonía fija o móvil.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen5} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans5.valid}
              type="checkbox"
              value="1"
              checked={answers.ans5.value === "1"}
              onChange={(event) => handleAnswers(event, "ans5")}
            />{" "}
            <p className="w-200 ms-2">Tener acceso a transporte.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen6} alt="Peruanos" className="img-fluid img-80" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans6.valid}
              type="checkbox"
              value="1"
              checked={answers.ans6.value === "1"}
              onChange={(event) => handleAnswers(event, "ans6")}
            />{" "}
            <p className="w-200 ms-2">Recibir una buena atención de salud.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen7} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans7.valid}
              type="checkbox"
              value="1"
              checked={answers.ans7.value === "1"}
              onChange={(event) => handleAnswers(event, "ans7")}
            />{" "}
            <p className="w-200 ms-2">Tener electrodomésticos.</p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-6">
          <img src={Imagen8} alt="Peruanos" className="img-fluid" />
          <div className="d-flex mt-2">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans8.valid}
              type="checkbox"
              value="1"
              checked={answers.ans8.value === "1"}
              onChange={(event) => handleAnswers(event, "ans8")}
            />{" "}
            <p className="w-200 ms-2">Recibir una buena alimentación.</p>
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo12.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <div className="row mt-5">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>
            Múestrale tus respuestas a un compañero, compañera o familiar y pregúntale qué opciones marcaría. Fíjense en lo siguiente:
            </li>
          </ul>
          <p>¿En qué respuestas coincidieron?</p>
          <textarea className="form-control mb-3" rows={3} />
          <p>¿En qué respuestas no estuvieron de acuerdo?</p>
          <textarea className="form-control mb-3" rows={3} />
          <ul className="mt-5">
            <li>
              Conversen y traten de llegar a un acuerdo sobre cuáles son las
              necesidades básicas de las personas. No se olviden explicar el
              porqué de sus respuestas.
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Presente a niños y niñas el trabajo que realizarán. En este caso,
            se trata de actividades que apuntan a que los niños y niñas se
            introduzcan, a partir del diálogo, en temas complejos como son las
            necesidades básicas, las oportunidades y la desigualdad.
          </li>

          <li>
            Lea la primera indicación: Las personas no podemos vivir bien si nuestras necesidades básicas no están cubiertas. Abajo aparecen diferentes tipos de necesidades. Marca con un check aquellas que creas que son necesidades básicas.
          </li>

          <li>
            Pregunte a niñas y niños cómo podrían definir el concepto de
            necesidades básicas. Para ello, puede retomar el ejercicio de la
            Actividad 4 de la Unidad 2:
            <ul>
              <li>
                <i>
                  “En la Actividad 4 de la Unidad 2 vimos dos tipos de
                  necesidades. Dijimos que la necesidad que se presenta en el
                  Caso 1 (alimentar bien a los niños para que crezcan) es
                  importante para sobrevivir. ¿Podríamos decir entonces que se
                  trata de una necesidad básica? Claro. Las necesidades básicas
                  son un conjunto de aspectos que resultan fundamentales para
                  poder tener calidad de vida”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora pida a niños y niñas que desarrollen la actividad. Déles un
            tiempo para que la realicen solos y luego pase a la siguiente
            actividad.
          </li>

          <li>
            Lea la primera indicación:
            Compara tus respuestas de la actividad anterior con las de un
            compañero, compañera o familiar. Fíjense en lo siguiente: ¿En qué respuestas
            coincidieron? ¿En qué respuestas no estuvieron de acuerdo?
          </li>

          <li>
            Una vez que hayan comparado las respuestas, lea la segunda
            indicación. Traten de llegar a un acuerdo sobre cuáles son las
            necesidades básicas de las personas. No se olviden de explicar el
            porqué de sus respuestas.
          </li>

          <li>
            Ahora, lea cada una de las necesidades propuestas en la actividad 6
            y mencione, retomando las respuestas, cuáles son
            necesidades básicas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “Vamos a leer la primera necesidad: tener un sitio adecuado y
                  seguro donde vivir. ¿Creen que se trata de una necesidad
                  básica? ¿Por qué? En efecto, resulta fundamental contar con un
                  lugar donde vivir. Asimismo, este tiene que ser adecuado y
                  seguro. La vivienda cubre aspectos esenciales como la
                  provisión de abrigo, el ser un lugar para dormir y descansar,
                  de protección y privacidad para las personas”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Siga así con las demás opciones. Tenga en cuenta que son necesidades
            básicas tener un sitio adecuado y seguro donde vivir, recibir una
            buena educación, tener agua y desagüe, recibir una buena atención de
            salud y recibir una buena alimentación.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
